export default __webpack_public_path__ + "static/media/banner-bottom.56dd3471.png";